import { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { v4 } from "uuid";

import { CustomPaginationActionsTable } from "./";

import { Receipt, CoOwner } from "../../interfaces";
import { ROWS_PER_PAGE, EXCHANGE_RATE } from "../../../constants";

interface IProps {
  coOwners: CoOwner[];
  receipts: Receipt[];
}

// receipt drills through two level, it is okay for now
export const ReceiptsTable = ({ coOwners, receipts }: IProps) => {
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [receipts]);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * ROWS_PER_PAGE - receipts.length) : 0;

  return (
    <TableContainer
      sx={{
        overflowX: "auto",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Table aria-label="simple table" sx={{ maxWidth: "90%" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "600" }}>Ime</TableCell>
            <TableCell align="right" sx={{ fontWeight: "600" }}>
              Datum
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "600" }}>
              Iznos
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: "600" }}>
              Uplaćeno
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(ROWS_PER_PAGE > 0
            ? receipts.slice(
                page * ROWS_PER_PAGE,
                page * ROWS_PER_PAGE + ROWS_PER_PAGE
              )
            : receipts
          )?.map((receipt: Receipt) => {
            const amount = receipt?.currency === "EUR" ? receipt.amount.toFixed(2) : (receipt.amount / EXCHANGE_RATE).toFixed(2);
            const paid = receipt?.currency === "EUR" ? receipt.amount.toFixed(2) : (receipt.amount / EXCHANGE_RATE).toFixed(2);
            return (
              <TableRow
                key={v4()}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {coOwners.find((co: CoOwner) => co.id === receipt.coowner)
                    ?.name}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  {`${receipt.date.month}.${receipt.date.year}.`}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  {amount}eura
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  {paid}eura
                </TableCell>
              </TableRow>
            );
          })}
          {emptyRows > 0 && (
            <TableRow key={v4()} style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <tfoot>
          <CustomPaginationActionsTable
            rows={receipts}
            page={page}
            setPage={setPage}
          />
        </tfoot>
      </Table>
    </TableContainer>
  );
};
